import { render, staticRenderFns } from "./gc-sales-contract-note-attachments.vue?vue&type=template&id=363dc0e9"
import script from "./gc-sales-contract-note-attachments.vue?vue&type=script&lang=js"
export * from "./gc-sales-contract-note-attachments.vue?vue&type=script&lang=js"
import style0 from "./gc-sales-contract-note-attachments.vue?vue&type=style&index=0&id=363dc0e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports